/* eslint-disable */
import axios from "axios";
import moment from "moment";
import store from "../../store/index";
import customModal from "../customModal/customModal.vue";
import showformmodel from "../showformmodel/showformmodel.vue"
import manageVisitModal from "../manageVisitModal/manageVisitModal.vue";
import VisitActivityModal from "../VisitActivityOrder/VisitActivityOrder.vue"
import CreateScheduleCyclePopUp from "../ScheduleCyclePopup/ScheduleCyclePopup.vue";

export default {
    name: "VisitActivityTree",
    props: {
        visitData: {
            type: Object,
            required: true
        },
        version: {
            type: String,
            required: false
        },
        optionsshow: {
            type: Boolean,
            default: true
        }
    },
    components: {
        customModal,
        showformmodel,
        manageVisitModal,
        VisitActivityModal,
        CreateScheduleCyclePopUp
    },
    data() {
        return {
            baseapi: process.env.VUE_APP_Service_URL,
            token: store.getters.getIdToken,
            head: {},
            studyId: "",
            visitList: [],
            visitTreeList: [],
            activityList: [],
            activityObj: {},
            openedVisitArray: [],
            formList: [],
            setshowActivityFormModal: false,
            showVisitPopup: [false],
            formActivityId: "",
            loading: false,
            selectedArm: "",
            armList: [],
            showVisitPopup: [],
            rollsprivilages:"",
            showSiteModal: false,
            visitId: null,
            showActivityModal: false,
            SelectedVisitId: null,
            selectedVersion: this.version || "",
            visitExpanded: [],
            title: "",
            baseurl: process.env.VUE_APP_Service_URL,
            isArmSpecific: false,
            studyDetails: {},
            versiondetailsobj: {},
            defaultdate: "",
            CreateScheduleCyclePopUp: false,
            selectedCycleId: null,
            selectedPatientId: null,
            showCycleSidePopup: {},
            visitTreeList : []


        };
    },
    computed: {
        hasRepeatCycleSubject() {
            return !!this.getRepeatCycleSubjectId();
        }
    },
    async mounted() {
         this.rollsprivilages = await store.getters.getRolesprivilegeData;
        this.head = {
            headers: {
                Authorization: "Bearer " + this.token,
                "Content-Type": "application/json",
            },
        };
         if (this.$route.name !== "visitInfo"){
            this.title = this.$t("navigations.soa")
         }
        this.studyId = store.getters.getStudyIs;
        this.defaultdate = localStorage.getItem("dateformat");
        await this.getVlists();
        // await this.getStudyArms();
        window.addEventListener("studyIdChanged", async () => {
            this.studyId = store.getters.getStudyIs
            await this.getVlists();
           this.$emit("study-changed", this.studyId);
        });
    },

    methods: {
         async getStudyDetails() {
            try {
                const res = await axios.get(
                    `${this.baseurl}/management/study/getbyid?id=${this.studyId}`,
                    this.head
                );
                this.studyDetails = res.data;
                this.versiondetailsobj = res.data;
                    const currentVersion = res.data.currentVersion;
                    this.version = currentVersion;

                    const versionObj = res.data.versions.find(
                        v => v.version === currentVersion
                    );

                    this.isArmSpecific = versionObj ? versionObj.isArmSpecific : false;
                     this.routpage();
            } catch (err) {
                console.log("error in get study", err);
            }
        },
        buildSoATree(visits) {

            if (!visits || !visits.length) return [];

            const soaMap = {};
            const rootNodes = [];

            visits.forEach((visit, index) => {

                visit.__visitIndex = index;

                // ROOT LEVEL (NO SOA)
                if (!visit.soAId) {

                    // ---------------- PHASE ----------------
                    if (visit.studyPhase) {

                        let phaseNode = rootNodes.find(
                            x =>
                                x.type === "phase" &&
                                x.phaseName === visit.studyPhase
                        );

                        if (!phaseNode) {

                            phaseNode = {
                                type: "phase",
                                phaseName: visit.studyPhase,
                                displayText: visit.studyPhase,
                                visits: [],
                                nodes: []
                            };

                            rootNodes.push(phaseNode);
                        }

                        phaseNode.visits.push(visit);

                    } else {

                        // ---------------- DIRECT ROOT ----------------
                        rootNodes.push(visit);
                    }

                    return;
                }

                // SOA GROUPING
                if (!soaMap[visit.soAId]) {
                    soaMap[visit.soAId] = [];
                }

                soaMap[visit.soAId].push(visit);

            });

            const soaTree = [];

            // BUILD SOA TREE
            Object.keys(soaMap).forEach((soaId) => {

                const soaVisits = soaMap[soaId];

                const phaseMap = {};
                const directVisits = [];

                soaVisits.forEach((visit) => {

                    // ---------------- PHASE GROUP ----------------
                    if (visit.studyPhase) {

                        if (!phaseMap[visit.studyPhase]) {
                            phaseMap[visit.studyPhase] = [];
                        }

                        phaseMap[visit.studyPhase].push(visit);

                        return;
                    }

                    // ---------------- DIRECT VISIT/CYCLE ----------------
                    directVisits.push(visit);

                });

                // PHASE NODES
                const phaseNodes = Object.keys(phaseMap).map((phaseName) => {

                    return {
                        type: "phase",
                        phaseName,
                        displayText: phaseName,
                        visits: phaseMap[phaseName],
                        nodes: this.buildVisitTree(phaseMap[phaseName])
                    };

                });

                // FINAL SOA NODE
                soaTree.push({

                    type: "soa",
                    soaId,
                    displayText: soaVisits[0]?.soAName || soaId,

                    nodes: [
                        ...phaseNodes,
                        ...this.buildVisitTree(directVisits)
                    ]

                });

            });

            // ROOT PROCESSING
            const processedRootNodes = [];

            rootNodes.forEach((item) => {

                // ---------------- ROOT PHASE ----------------
                if (item.type === "phase") {

                    const builtNodes = this.buildVisitTree(item.visits);

                    processedRootNodes.push({
                        ...item,
                        nodes: builtNodes
                    });

                    return;
                }

                // ---------------- ROOT VISIT/CYCLE ----------------
                processedRootNodes.push(
                    ...this.buildVisitTree([item])
                );

            });

            return [
                ...soaTree,
                ...processedRootNodes
            ];
        },
        async getVlists() {
            this.loading = true;
            this.visitList = [];
            try {
                const response = await axios.get(
                    `${this.baseapi}/management/visit/listvisit?StudyId=${this.studyId}&StudyVersion=${this.version}&ArmCode=${this.selectedArm}&SortProperty=visitOrder&pageindex=1&pagesize=10000`, this.head
                );
                console.log("Visit Activity Orders Response:", response.data);
                this.visitList = response.data.results;
                // this.visitTreeList = this.buildVisitTree(this.visitList);
               
                   this.visitTreeList = this.buildSoATree(this.visitList);
                
                this.visitList.forEach(visit => {
                    this.activityList[visit.visitId] = [];
                });
                this.showVisitPopup = this.visitList.map(() => false);
                this.visitExpanded = this.visitList.map(() => false);

                this.loading = false;
            } catch (error) {
                console.error("Error fetching Visit Activity Orders:", error);
            }
        },
        buildVisitTree(visits) {
            const tree = [];
            const cycleMap = {};

            visits.forEach((visit, index) => {
                if (visit.__visitIndex === undefined || visit.__visitIndex === null) {
                    visit.__visitIndex = index;
                }

                if (visit.isCycleVisit) {
                    const key = `${visit.cycleName}`;

                    if (!cycleMap[key]) {
                        cycleMap[key] = {
                            type: "cycle",
                            cycleName: visit.cycleName,
                            occurence: visit.occurence,
                            cycleId: visit.cycleId,
                            displayText: `${visit.cycleName}`,
                            visits: []
                        };

                        tree.push(cycleMap[key]);
                    }

                    cycleMap[key].visits.push(visit);
                } else {
                    tree.push({
                        type: "visit",
                        visit
                    });
                }
            });

            Object.values(cycleMap).forEach(cycle => {
                cycle.visits.sort((a, b) => {
                    const dayA = extractDay(a.visitNo);
                    const dayB = extractDay(b.visitNo);

                    if (dayA !== null && dayB !== null) return dayA - dayB;
                    const dateA = getVisitSortDate(a);
                    const dateB = getVisitSortDate(b);
                    if (dateA && dateB) return dateA - dateB;
                    if (dateA) return -1;
                    if (dateB) return 1;

                    return String(a.visitNo || "").localeCompare(String(b.visitNo || ""));
                });
            });

            return tree.sort((a, b) => {
                const dateA = a.type === "visit"
                    ? getVisitSortDate(a.visit)
                    : getCycleSortDate(a);
                const dateB = b.type === "visit"
                    ? getVisitSortDate(b.visit)
                    : getCycleSortDate(b);

                if (dateA && dateB) return dateA - dateB;
                if (dateA) return -1;
                if (dateB) return 1;

                return 0;
            });

            function extractDay(visitNo) {
                const match = visitNo?.match(/D(\d+)/i);
                return match ? parseInt(match[1], 10) : null;
            }

            function getVisitSortDate(visit) {
                if (!visit) return null;
                if (visit.visitStatus === "Completed" || visit.visitStatus === "In Progress") {
                    return visit.actualVisitStartDate ? new Date(visit.actualVisitStartDate) : null;
                }
                return visit.visitDate ? new Date(visit.visitDate) : null;
            }

            function getCycleSortDate(cycle) {
                if (!cycle?.visits?.length) return null;
                const dates = cycle.visits
                    .map(v => getVisitSortDate(v))
                    .filter(Boolean)
                    .sort((a, b) => a - b);
                return dates.length ? dates[0] : null;
            }
        },
        filter(data) {
            if (data) {
                return moment(data)
                    .utc()
                    .format(this.defaultdate);
            }
        },
        setdate(visitobj) {
            let datereturn = "";
            if (visitobj.visitStatus == "Completed" || visitobj.visitStatus == "In Progress") {
                datereturn = this.filter(visitobj.actualVisitStartDate);
            } else {
                datereturn = this.filter(visitobj.visitDate);
            }
            return datereturn;
        },
        getRepeatCycleSubjectId() {
            return (
                this.visitData?.subjectId ||
                this.visitData?.patientId ||
                this.visitData?.patientid ||
                null
            );
        },
        openScheduleCyclePopup(cycleId) {
            const subjectId = this.getRepeatCycleSubjectId();
            if (!subjectId) {
                alert("Subject not found for repeat cycle.");
                return;
            }
            this.selectedPatientId = subjectId;
            this.selectedCycleId = cycleId;
            this.CreateScheduleCyclePopUp = true;
        },
        toggleCycleSidePopup(nodeIndex) {
            this.showCycleSidePopup = {
                ...this.showCycleSidePopup,
                [nodeIndex]: !this.showCycleSidePopup[nodeIndex]
            };
        },
        closeCycleSidePopup(nodeIndex) {
            if (!this.showCycleSidePopup[nodeIndex]) return;
            this.showCycleSidePopup = {
                ...this.showCycleSidePopup,
                [nodeIndex]: false
            };
        },
         async visitPopup(visitIdEdit, id) {
      if (id) {
        document.getElementById(id).style.display = "none"
      }
      this.showSiteModal = true
      this.visitId = visitIdEdit
    },
    async closeModal() {
      this.showSiteModal = false;
      await this.getVlists();
    },
        async getActivities(visitId, vIndex) {
            let openedActivity = {
                "visitId": visitId,
                "index": vIndex
            }
            const existingIndex = this.openedVisitArray.findIndex(
                item => item.visitId === visitId && item.index === vIndex
            );

            if (existingIndex !== -1) {
                this.openedVisitArray.splice(existingIndex, 1);
            } else {
                this.openedVisitArray.push(openedActivity);
            }

            try {
                const response = await axios.get(
                    `${this.baseapi}/management/visit/listvisitactivity?visitId=${visitId}&pageindex=1&pagesize=10000`, this.head
                );
                let data = response.data.entities || [];
                await data.forEach(visitData => {
                    this.formList[visitData.activityId] = [];
                });
                this.activityList[visitId][vIndex] = data;
            } catch (error) {
                console.error("Error fetching Activities for VisitId " + visitId + ":", error);
            }
        },
        async getActivityForms(activityId, aIndex) {
            try {
                const response = await axios.get(
                    `${this.baseapi}/management/study/getsoa?Id=${activityId}`, this.head
                );
                console.log("SOA Response:", response.data);
                this.formList[activityId][aIndex] = response.data.eCRF;
                console.log("Form List:", this.formList);
            } catch (error) {
                console.error("Error fetching SOA:", error);
            }
        },
        async viewForms(tempId) {
            this.formActivityId = tempId;
            this.setshowActivityFormModal = true;
        },
        closeformActivityModal() {
            this.setshowActivityFormModal = false;
        },
        async getStudyArms() {
            try {
                const response = await axios.get(
                    `${this.baseapi}/fhir-service/arm/getarmsbystudyid?study_id=${this.studyId}`, this.head
                );
                console.log("Study Arms Response:", response.data);
                this.armList = response.data;
            }
            catch (error) {
                console.error("Error fetching Study Arms:", error);
            }
        },
        toggleVisitMenu(index) {
 
            this.showVisitPopup = this.showVisitPopup.map(() => false);

            this.showVisitPopup[index] = true;

        },
        async deleteVisit(id) {
             this.closePopover();
            if (confirm(this.$t('navigations.are you sure you want to delete this visit?'))) {
                try {
                    await axios.delete(
                        `${this.baseapi}/management/visit/delete?id=${id}`,
                        this.head
                    );

                    alert(this.$t("navigations.visit deleted successfully"));
                    this.getVlists();
                } catch (err) {
                    alert(this.$t("navigations.failed due to internal error"));
                    console.error(err);
                }
            }

            this.showVisitPopup = this.showVisitPopup.map(() => false);
        },
        visitPopup(visitId) {
             this.closePopover(`visit-popup-${visitId}`);
            this.showVisitPopup = this.showVisitPopup.map(() => false);
            this.showSiteModal = true;
            this.visitId = visitId;
        },
        openVisitActivityModal(visitId) {
             this.closeAllPopovers();
            this.SelectedVisitId = visitId;
            this.showActivityModal = true;
        },
        async closeModal() {
            this.showSiteModal = false;
            await this.getStudyDetails();
            await this.getVlists();
        },

        toggleVisit(vIndex, visitId) {
            this.visitExpanded[vIndex] = !this.visitExpanded[vIndex];

            if (this.visitExpanded[vIndex]) {
                this.getActivities(visitId, vIndex);
            }
        },
        visitInputId(visit) {
            return `visit-${visit.__visitIndex}-${visit.visitId}`;
        },
         closePopover(popoverId) {
            const popover = document.getElementById(popoverId);
            if (popover && typeof popover.hidePopover === 'function') {
                popover.hidePopover();
            }
        },

     closeAllPopovers() {
    this.visitList.forEach(visit => {
        if (visit && visit.visitId) {
            this.closePopover(`visit-popup-${visit.visitId}`);
        }
    });
},
closeActivityModal() {
            this.showActivityModal = false;
            this.getVlists();
        }
    }
};
